// First Created - 03 Jun 2025
// Author - Atul Pandey
// Purpose - use it for formatting ai messages in different Trinity Service Bars

export const formatAiMessage = (text) => {
  if (!text) return "";

  // Headers (Markdown-style `#`)
  text = text.replace(/^# (.*$)/gm, "<h2 class='text-lg font-bold'>$1</h2>");

  // Bullets and numbers
  text = text.replace(/^-\s(.*$)/gm, "<li class='ml-4 list-disc'>$1</li>");
  text = text.replace(/^\d+\.\s(.*$)/gm, "<li class='ml-4 list-decimal'>$1</li>");
  text = text.replace(/(<li class='ml-4 list-disc'>.*<\/li>)/g, "<ul class='mb-2'>$1</ul>");
  text = text.replace(/(<li class='ml-4 list-decimal'>.*<\/li>)/g, "<ol class='mb-2'>$1</ol>");

  // Paragraphs
  text = text.replace(/\n\n/g, "</p><p class='mb-2'>");

  return `<p class='mb-2'>${text}</p>`;
};
